import { serviceMixin } from "@/mixins/serviceMixin";
export const verkoopMixin = {
  mixins: [serviceMixin],
  data() {
    return {
      busy: false
    };
  },
  methods: {
    getTraject(url) {
      console.log("ophalen traject");
      var vm = this;
      vm.busy = true;
      return this.get(url)
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    createTraject(url, traject) {
      var vm = this;
      vm.busy = true;
      return this.post(url, traject)
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    updateTraject(url, traject) {
      var vm = this;
      vm.busy = true;
      return this.put(url, traject)
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    deleteTraject(url, traject) {
      var vm = this;
      vm.busy = true;
      return this.delete(url, traject)
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    insertTrajectTaak(url, taak) {
      console.log(url);
      console.log(taak);
      var vm = this;
      vm.busy = true;
      return this.post(url, taak)
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    updateTrajectTaak(url, taak) {
      console.log(url);
      console.log(taak);
      var vm = this;
      vm.busy = true;
      return this.put(url, taak)
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    deleteTrajectTaak(url, taak) {
      console.log(url);
      console.log(taak);
      var vm = this;
      vm.busy = true;
      return this.deletePost(url, taak)
        .catch(function(error) {
          console.log(error);
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    emitUpdate(o) {
      this.$emit("update", o);
      this.goBack();
    },
    emitDelete(o) {
      this.$emit("delete", o);
      this.goBack();
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
